import fetch from 'fetch-everywhere';
import {polyfill} from 'es6-promise';

polyfill();

const timeoutPromise = (fetchFunc, timeout, error) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(error);
    }, timeout);
    fetchFunc.then((response) => {
      clearTimeout(timer);
      return resolve(response);
    }, reject);
  });
};

export const fetchWithTimeout = (url, options, timeout) => {
  return timeoutPromise(fetch(url, options), timeout, 'Timeout error');
};
